import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { FadeUp } from '../motion/FadeUp';
import { LogoMark } from '../brand/Logo';
const HERO_ARTWORK = 'https://cdn.magicpatterns.com/uploads/jZRZ1nZzSdGtZGnLyLrxsz/Gemini_Generated_Image_1wftg31wftg31wft.png';
export function Hero() {
  return <section id="top" className="relative flex min-h-[900px] w-full items-center justify-center overflow-hidden bg-white px-6 pt-24 pb-20 md:min-h-[1080px]" data-id="element-121" data-mp="hv7k3lbsv75j">
      {/* Fully contained yantra artwork, positioned below the Haerumbah brand line. */}
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-[71%] h-[122vw] max-h-[600px] w-[122vw] max-w-[600px] -translate-x-1/2 -translate-y-1/2 opacity-10" style={{
      backgroundImage: `url(${HERO_ARTWORK})`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      maskImage: 'radial-gradient(circle, #000 58%, transparent 84%)',
      WebkitMaskImage: 'radial-gradient(circle, #000 58%, transparent 84%)'
    }} data-id="element-122" data-mp="qt9jjwfvxrqp" />

      <div className="relative mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-123" data-mp="4n4ysjhu8m9f">
        <FadeUp data-id="element-124" data-mp="3vvsk4zg2w9gz">
          <LogoMark className="mx-auto h-16 w-16 md:h-20 md:w-20" data-id="element-125" data-mp="3vvaskg4d2jfe" />
        </FadeUp>

        <FadeUp delay={0.08} data-id="element-126" data-mp="3ruqsb3ohqzp1">
          <p className="mt-8 text-sm font-medium uppercase tracking-[0.26em] text-vermillion sm:text-[15px]" data-id="element-127" data-mp="3rvs79j8mo6c1">
            Haerumbah Pvt Ltd
          </p>
        </FadeUp>

        <FadeUp delay={0.14} data-id="element-128" data-mp="nfr37s6t9l5m">
          <h1 className="mt-5 text-4xl font-semibold leading-[1.08] tracking-tightest text-ink sm:text-5xl md:text-6xl" data-id="element-129" data-mp="nhk04frmgr0f">
            Building products that make everyday life happier &amp; healthier.
          </h1>
        </FadeUp>

        <FadeUp delay={0.22} data-id="element-130" data-mp="1b5boihqfsui2">
          <p className="mx-auto mt-7 max-w-xl text-lg leading-relaxed text-ink/60" data-id="element-131" data-mp="1b5lbdwg6qljj">
            We create thoughtful technology that enriches everyday experiences,
            strengthens communities, and helps people live happier, healthier lives.
          </p>
        </FadeUp>

        <FadeUp delay={0.3} data-id="element-132" data-mp="35jyx2w0g2c8p">
          <p className="mt-6 text-[15px] text-ink/50" data-id="element-133" data-mp="35k8p0p51uth1">
            <span className="font-medium text-ink/80" data-id="element-134" data-mp="2qwnjkokpci5y">Our Vision:</span>{' '}
            <span className="italic" data-id="element-135" data-mp="2vv79f02f2e3l">Creating a Happy Healthy Humanity.</span>
          </p>
        </FadeUp>

        <FadeUp delay={0.38} data-id="element-136" data-mp="2hvpee2yj24ls">
          <div className="mt-10 flex justify-center" data-id="element-137" data-mp="2hueb048zuyv7">
            <a href="#product" className="group inline-flex items-center gap-2 rounded-full bg-[#2f5f1e] px-7 py-3.5 text-[15px] font-medium text-white transition-colors hover:bg-[#244a17]" data-id="element-138" data-mp="2muiu821ae7p4">
              Explore Kraya
              <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" data-id="element-139" data-mp="2cwuxx7o18s4u" />
            </a>
          </div>
        </FadeUp>
      </div>
    </section>;
}